export enum PrecedentStatusEnum {
  Approved = 1,
  Reproved = 2,
  NoLongerApplies = 3,
  Waiting = 4,
}
